import { render, staticRenderFns } from "./MindMap.vue?vue&type=template&id=0fe89bf5&"
import script from "./MindMap.vue?vue&type=script&lang=ts&"
export * from "./MindMap.vue?vue&type=script&lang=ts&"
import style0 from "./MindMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports